/** Enums */
import { DsLibVinciUsersEnums } from '../enums/ds-lib-vinci-users.enums';

export const BYD_SSO_DOMAINS = [
  DsLibVinciUsersEnums.VINCI_COM,
  DsLibVinciUsersEnums.VINCI_FR,
  DsLibVinciUsersEnums.VC_PARTNER_NET,
];
